<template>
  <div class="stats-chart">
    <canvas ref="canvas" :width="width" :height="height" />
  </div>
</template>

<script>
/**
 * Chart used in shizen stats
 */
import { Chart } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';

export default {

  name: 'StatsChart',

  props: {
    chartData: {
      type: Object,
      required: true,
    },
    options: {
      type: Object,
      required: true,
    },
    width: {
      type: Number,
      default: 100,
    },
    height: {
      type: Number,
      default: 70,
    },
  },

  data() {
    return {
      chart: null,
    };
  },

  watch: {
    chartData: {
      handler() {
        this.buildChart();
      },
      deep: true,
    },
  },

  mounted() {
    this.buildChart();
  },

  beforeDestroy() {
    if (this.chart) {
      this.chart.destroy();
    }
  },

  methods: {
    buildChart() {
      if (this.chart) {
        this.chart.destroy();
      }

      this.chart = new Chart(this.$refs.canvas.getContext('2d'), {
        plugins: [ChartDataLabels],
        type: this.chartData.type,
        data: this.chartData,
        options: this.options,
      });
    },
  },
};
</script>
